/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import HeaderPDF from './HeaderPDF';
// Define styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 20,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    textDecoration: 'underline',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    border: '1px solid #000',
  },
  sectionHeader: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10,
    backgroundColor: '#f0f0f0',
    padding: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'center',
  },
  label: {
    fontSize: 10,
    fontWeight: 'bold',
    minWidth: 120,
    marginRight: 10,
  },
  value: {
    fontSize: 10,
    flex: 1,
    borderBottom: '1px solid #000',
    paddingBottom: 2,
    minHeight: 12,
  },
  checkbox: {
    width: 10,
    height: 10,
    border: '1px solid #000',
    marginRight: 5,
    textAlign: 'center',
    fontSize: 8,
  },
  checkboxChecked: {
    width: 10,
    height: 10,
    border: '1px solid #000',
    marginRight: 5,
    backgroundColor: '#000',
    textAlign: 'center',
    fontSize: 8,
    color: '#fff',
  },
  radioGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 8,
  },
  radioOption: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 20,
    marginBottom: 5,
  },
  radio: {
    width: 8,
    height: 8,
    borderRadius: 4,
    border: '1px solid #000',
    marginRight: 5,
  },
  radioChecked: {
    width: 8,
    height: 8,
    borderRadius: 4,
    border: '1px solid #000',
    backgroundColor: '#000',
    marginRight: 5,
  },
  radioLabel: {
    fontSize: 9,
  },
  textArea: {
    border: '1px solid #000',
    padding: 5,
    minHeight: 40,
    fontSize: 9,
    lineHeight: 1.2,
  },
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    paddingTop: 10,
    borderTop: '1px solid #000',
  },
  signatureBox: {
    width: '45%',
    textAlign: 'center',
  },
  signatureLine: {
    borderBottom: '1px solid #000',
    marginBottom: 5,
    minHeight: 30,
    fontSize: 9,
    paddingTop: 15,
  },
  signatureLabel: {
    fontSize: 8,
    textAlign: 'center',
  },
});

const ExportPDFESafetyAgreementFormFDWEmployer = ({ formData, user,agencyInfo }) => {


  const renderRadioGroup = (name, options, selectedValue) => (
    <View style={styles.radioGroup}>
      {options.map((option) => (
        <View key={option.value} style={styles.radioOption}>
          <View style={selectedValue === option.value ? styles.radioChecked : styles.radio} />
          <Text style={styles.radioLabel}>{option.label}</Text>
        </View>
      ))}
    </View>
  );

  const renderCheckboxGroup = (name, options, selectedValues = []) => (
    <View style={styles.radioGroup}>
      {options.map((option) => (
        <View key={option.value} style={styles.radioOption}>
          <View style={selectedValues.includes(option.value) ? styles.checkboxChecked : styles.checkbox}>
            {selectedValues.includes(option.value) && <Text style={{ color: '#fff', fontSize: 6 }}>✓</Text>}
          </View>
          <Text style={styles.radioLabel}>{option.label}</Text>
        </View>
      ))}
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header with company info */}
        <HeaderPDF user={user}  agencyInfo={agencyInfo} />

        <Text style={styles.title}>
          Safety Agreement Between Migrant Domestic Worker and Employer
        </Text>

        {/* Part A - Employer */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Part A – Employer</Text>
          
          <View style={styles.row}>
            <Text style={styles.label}>Name of Employer:</Text>
            <Text style={styles.value}>{formData.employerName || ''}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>NRIC / FIN (last 4 chars):</Text>
            <Text style={styles.value}>{formData.employerNric || ''}</Text>
          </View>

          <View style={{ marginBottom: 10 }}>
            <Text style={[styles.label, { marginBottom: 5 }]}>Residential Dwelling Type:</Text>
            {renderRadioGroup('dwelling', [
              { value: 'HDB', label: 'HDB Apartment' },
              { value: 'Private', label: 'Private Apartment / Condo' },
              { value: 'Landed', label: 'Landed Property' }
            ], formData.dwelling)}
          </View>

          <View style={{ marginBottom: 10 }}>
            <Text style={[styles.label, { marginBottom: 5 }]}>Require MDW to clean window exterior?</Text>
            {renderRadioGroup('cleanExterior', [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' }
            ], formData.cleanExterior)}
          </View>

          <View style={{ marginBottom: 10 }}>
            <Text style={[styles.label, { marginBottom: 5 }]}>Location of window exterior:</Text>
            {renderCheckboxGroup('location', [
              { value: 'Ground', label: 'On the ground' },
              { value: 'Corridor', label: 'Facing common corridor' },
              { value: 'Others', label: 'Others' }
            ], formData.location || [])}
          </View>

          <View style={{ marginBottom: 10 }}>
            <Text style={[styles.label, { marginBottom: 5 }]}>Grilles installed?</Text>
            {renderRadioGroup('grilles', [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' }
            ], formData.grilles)}
          </View>

          <View style={{ marginBottom: 10 }}>
            <Text style={[styles.label, { marginBottom: 5 }]}>Adult supervision when cleaning?</Text>
            {renderRadioGroup('supervision', [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' }
            ], formData.supervision)}
          </View>

          <View style={{ marginBottom: 10 }}>
            <Text style={[styles.label, { marginBottom: 5 }]}>Employer Declaration:</Text>
            {renderRadioGroup('empDecl', [
              { value: 'Not required', label: 'Not require MDW to clean exterior' },
              { value: 'Ground', label: 'Only ground floor exterior' },
              { value: 'Corridor', label: 'Only corridor exterior' },
              { value: 'Supervised', label: 'With locked grilles + supervision' }
            ], formData.empDecl)}
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Signature / Date:</Text>
            <Text style={styles.value}>{formData.empSignature || ''}</Text>
          </View>
        </View>

        {/* Part B - Employment Agency Personnel */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Part B – Employment Agency Personnel</Text>
          
          <View style={styles.row}>
            <Text style={styles.label}>Name of EAP / KAH:</Text>
            <Text style={styles.value}>{formData.eapName || ''}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Registration number:</Text>
            <Text style={styles.value}>{formData.eapReg || ''}</Text>
          </View>

          <View style={{ marginBottom: 10 }}>
            <Text style={styles.label}>Declaration:</Text>
            <View style={styles.textArea}>
              <Text>{formData.eapDecl || ''}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Signature / Date:</Text>
            <Text style={styles.value}>{formData.eapSignature || ''}</Text>
          </View>
        </View>

        {/* Part C - Migrant Domestic Worker */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Part C – Migrant Domestic Worker</Text>
          
          <View style={styles.row}>
            <Text style={styles.label}>Name of MDW:</Text>
            <Text style={styles.value}>{formData.mdwName || ''}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Work Permit No (last 4 digits):</Text>
            <Text style={styles.value}>{formData.mdwWp || ''}</Text>
          </View>

          <View style={{ marginBottom: 10 }}>
            <Text style={[styles.label, { marginBottom: 5 }]}>MDW Declaration:</Text>
            {renderRadioGroup('mdwDecl', [
              { value: 'Not required', label: 'Not required to clean exterior' },
              { value: 'Ground', label: 'Only ground floor exterior' },
              { value: 'Corridor', label: 'Only corridor exterior' },
              { value: 'Supervised', label: 'With locked grilles + supervision' }
            ], formData.mdwDecl)}
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Signature / Date:</Text>
            <Text style={styles.value}>{formData.mdwSignature || ''}</Text>
          </View>
        </View>

        {/* Part D - Employment Agency Personnel (Second) */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Part D – Employment Agency Personnel</Text>
          
          <View style={{ marginBottom: 10 }}>
            <Text style={styles.label}>Declaration:</Text>
            <View style={styles.textArea}>
              <Text>{formData.eapDecl2 || ''}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Signature / Date:</Text>
            <Text style={styles.value}>{formData.eapSignature2 || ''}</Text>
          </View>
        </View>

        {/* Final Signatures */}
        <View style={styles.signatureSection}>
          <View style={styles.signatureBox}>
            <View style={styles.signatureLine}>
              <Text>{formData.empSignature || ''}</Text>
            </View>
            <Text style={styles.signatureLabel}>Employer Signature</Text>
          </View>

          <View style={styles.signatureBox}>
            <View style={styles.signatureLine}>
              <Text>{formData.eapSignature2 || ''}</Text>
            </View>
            <Text style={styles.signatureLabel}>EAP Signature</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default ExportPDFESafetyAgreementFormFDWEmployer;
